export default __webpack_public_path__ + "50114233a7432c29c43de5d946442db6.ttf";